import { defineComponent, createBlock, openBlock, unref, withCtx, createVNode, mergeProps, renderSlot } from "vue";
import { cn } from "../../../../node_modules/.pnpm/tailwind-variants@3.2.2_tailwind-merge@3.3.0_tailwindcss@4.1.8/node_modules/tailwind-variants/dist/index.js";
import "../../../../node_modules/.pnpm/@uppy_locales@4.5.2/node_modules/@uppy/locales/lib/en_US.js";
import { useConfigProvider } from "../../config-provider/useConfigProvider.js";
import { u as useForwardPropsEmits } from "../../../../node_modules/.pnpm/reka-ui@2.3.1_typescript@5.8.3_vue@3.5.16_typescript@5.8.3_/node_modules/reka-ui/dist/shared/useForwardPropsEmits.js";
import { _ as _sfc_main$1 } from "../../../../node_modules/.pnpm/reka-ui@2.3.1_typescript@5.8.3_vue@3.5.16_typescript@5.8.3_/node_modules/reka-ui/dist/Tooltip/TooltipPortal.js";
import { _ as _sfc_main$2 } from "../../../../node_modules/.pnpm/reka-ui@2.3.1_typescript@5.8.3_vue@3.5.16_typescript@5.8.3_/node_modules/reka-ui/dist/Tooltip/TooltipContent.js";
import { _ as _sfc_main$3 } from "../../../../node_modules/.pnpm/reka-ui@2.3.1_typescript@5.8.3_vue@3.5.16_typescript@5.8.3_/node_modules/reka-ui/dist/Tooltip/TooltipArrow.js";
import { reactiveOmit } from "../../../../node_modules/.pnpm/@vueuse_shared@13.3.0_vue@3.5.16_typescript@5.8.3_/node_modules/@vueuse/shared/index.js";
const _sfc_main = /* @__PURE__ */ defineComponent({
  inheritAttrs: !1,
  __name: "TooltipContent",
  props: {
    class: {},
    forceMount: { type: Boolean },
    ariaLabel: {},
    asChild: { type: Boolean },
    as: {},
    side: {},
    sideOffset: { default: 4 },
    align: {},
    alignOffset: {},
    avoidCollisions: { type: Boolean },
    collisionBoundary: {},
    collisionPadding: {},
    arrowPadding: {},
    sticky: {},
    hideWhenDetached: { type: Boolean },
    positionStrategy: {},
    updatePositionStrategy: {}
  },
  emits: ["escapeKeyDown", "pointerDownOutside"],
  setup(__props, { emit: __emit }) {
    const props = __props, emits = __emit, delegatedProps = reactiveOmit(props, ["class"]), forwarded = useForwardPropsEmits(delegatedProps, emits), { teleportRenderDisabled } = useConfigProvider();
    return (_ctx, _cache) => (openBlock(), createBlock(unref(_sfc_main$1), { disabled: unref(teleportRenderDisabled) }, {
      default: withCtx(() => [
        createVNode(unref(_sfc_main$2), mergeProps({ "data-slot": "tooltip-content" }, { ...unref(forwarded), ..._ctx.$attrs }, {
          class: unref(cn)([
            "z-50 px-3 py-1.5 w-fit bg-(--gray-text-2) text-(--gray-bg-1) animate-in fade-in-0 zoom-in-95 rounded-md text-xs text-balance",
            "data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95",
            "data-[side=bottom]:slide-in-from-top-2",
            "data-[side=left]:slide-in-from-right-2",
            "data-[side=top]:slide-in-from-bottom-2",
            "data-[side=right]:slide-in-from-left-2"
          ], props.class)
        }), {
          default: withCtx(() => [
            renderSlot(_ctx.$slots, "default"),
            createVNode(unref(_sfc_main$3), { class: "z-50 size-2.5 bg-(--gray-text-2) fill-(--gray-text-2) translate-y-[calc(-50%_-_2px)] rotate-45 rounded-[2px]" })
          ]),
          _: 3
        }, 16, ["class"])
      ]),
      _: 3
    }, 8, ["disabled"]));
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=TooltipContent.js.map
